import { createGlobalStyle } from "styled-components";
import { v, b, t } from "./variables";

export const GlobalStyle = createGlobalStyle`
    
    *,
    *::after,
    &::before {
        margin: 0;
        padding: 0;
        box-sizing: 0;
    }

    html {
        scroll-behavior: smooth;
        font-size: 62,5%;
    }

    body {
        background: ${({ theme }) => theme.bg2};
        color: ${({ theme }) => theme.text};
        font-family: 'Outfit', sans-serif;
        font-size: 1.3rem;
        letter-spacing: .05rem;
        overflow-x: hidden;

	    @media ${b.medium} {
		font-size: 1.4rem;
	    }

	    @media ${b.large} {
		font-size: 1.6rem;
	    }
    }

    img {
        width: 100%;
    }

    svg {
        width: 100%;
    }

    h1 {
        color: ${({ theme }) => theme.primary};
    }

    h2 {
        color: ${({ theme }) => theme.primary};
        text-transform: uppercase;
        letter-spacing: 0.2rem;
        
    }

    a {
        color: ${({ theme }) => theme.primary};
    }

    button {
        border: 3px solid ${({ theme }) => theme.primary};
        outline: none;
        background: transparent;
        color: ${({ theme }) => theme.primary};
        font-size: 1.4rem;
        font-family: 'Outfit', sans-serif;
        border-radius: 5px;
        cursor: pointer;
        transition: all 0.3s ease-out;
        letter-spacing: .06rem;

        a {
            padding: 0.5rem ${v.smallDist};
            display: block;
        }



        &:hover {
            background: ${({ theme }) => theme.primary};
            border: 3px solid transparent;
            color: rgb(245, 245, 245);
        }

        &:hover > a {
            color: rgb(245, 245, 245);
        }

        &.light {
            border-radius: 25px;
            background: ${({ theme }) => theme.lightBg};
            border: none;
            color: ${({ theme }) => theme.textInvert};

            &:hover {
            background: ${({ theme }) => theme.primary};
            color: rgb(245, 245, 245);
        }
        }

        @media ${b.medium} {
            font-size: 1.6rem;
        }
    }

    a {
        text-decoration: none;
        color: ${({ theme }) => theme.primary};
        transition: ${t.fastSp};
    }

    ul {
        list-style: none;
    }

    ::-webkit-scrollbar {
    width: .60rem;
    background-color: ${({ theme }) => theme.lightBg};
    }
  
    ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.primary};
    }

`;
